"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    toolbarMenu: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    logo: {
      position: 'absolute',
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    avatar: {
      position: 'absolute',
      right: 16,
      padding: 0,
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    avatarMenu: {
      margin: 0,
      padding: 0
    },
    drawer: {
      width: 328,
      flexShrink: 0
    },
    drawerPaper: _defineProperty({
      width: 328,
      paddingBottom: 66
    }, theme.breakpoints.down(321), {
      width: 276
    }),
    drawerHeader: _objectSpread(_objectSpread({
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 2)
    }, theme.mixins.toolbar), {}, {
      justifyContent: 'flex-start'
    }),
    drawerMenuHeader: _objectSpread(_objectSpread({
      display: 'flex',
      alignItems: 'center',
      padding: theme.spacing(0, 2)
    }, theme.mixins.toolbar), {}, {
      justifyContent: 'flex-end'
    }),
    primaryText: _defineProperty({
      color: theme.palette.text.primary,
      width: 200
    }, theme.breakpoints.down(1300), {
      marginLeft: 16
    }),
    listUserStyle: _defineProperty({
      color: theme.palette.text.primary,
      width: 200
    }, theme.breakpoints.down(1300), {
      marginLeft: 16,
      marginTop: 13
    }),
    secondaryText: {
      color: theme.palette.text.secondary,
      fontSize: 14
    },
    menuAvatar: {
      marginRight: 16,
      marginBottom: 8
    },
    closeIcon: {
      fontSize: 24,
      marginTop: 16,
      marginBottom: 16
    },
    menuItem: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    },
    drawerIcon: {
      color: theme.palette.text.secondary,
      marginRight: 30
    },
    menuItemDrawer: {
      color: theme.palette.text.secondary,
      fontSize: 16,
      height: 48,
      padding: '0 16px'
    },
    menuItemFull: {
      color: theme.palette.text.secondary,
      fontSize: 16,
      height: 'auto',
      padding: '0 16px',
      overflow: 'visible'
    },
    iconMenu: {
      cursor: 'pointer'
    }
  };
});
var _default = useStyles;
exports.default = _default;